import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/element/theme/index.css'
import '@/assets/css/reset.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/css/quill.css'
import ElementUI from 'element-ui'
import VueQuillEditor from 'vue-quill-editor'
import * as filters from '@/utils/filter.js'
import '@/utils/hasPermi.js'
import uploader from 'vue-simple-uploader'
import '@/assets/css/question.css'
import Cookies from 'js-cookie'
import { parseTime, getRandomNum } from "@/utils/common";
import { message } from './utils/reset-message'

Vue.config.productionTip = false

Vue.use(ElementUI, {size: 'small'});
// 必须在这行命令后，覆盖 $message 方法
Vue.prototype.$message = message
Vue.use(VueQuillEditor);
Vue.use(uploader);

Vue.prototype.FILE_PREVIEW_URL = Cookies.get('FILE_PREVIEW_URL') || ''

Vue.prototype.parseTime = parseTime;
Vue.prototype.getRandomNum = getRandomNum;
Vue.prototype.flexColumnWidth = (str, len, tableData) =>{
    // str为该列的字段名(传字符串);len为该列的头部字符数量;tableData为该表格的数据源(传变量);
    str = str + ''
    let columnContent = ''
    if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) return
    if (!str || !str.length || str.length === 0 || str === undefined) return
    // 获取该列中最长的数据(内容)
    let index = 0
    for (let i = 0; i < tableData.length; i++) {
        const e = tableData[i]
        if (e[str] === null) return
        const now_temp = eval("e."+str) + '' || ''
        const max_temp = eval("tableData[index]."+str) + '' || ''
        if (now_temp.length > max_temp.length) index = i
    }
    columnContent = tableData[index][str]+'' || ''
    // console.log('该列数据[i]:', columnContent)
    // 以下分配的单位长度可根据实际需求进行调整
    let flexWidth = 0
    if (columnContent.length < len) flexWidth = len * 18
    else {
      for (const char of columnContent) {
        if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) flexWidth += 9
        else if (char >= '\u4e00' && char <= '\u9fa5') flexWidth += 18
        else flexWidth += 10
      }
      if (flexWidth < 80) flexWidth = 80
      if (flexWidth > 280) flexWidth = 280
    }
    return flexWidth + 'px'
}

String.prototype.signMix= function() {
    if(arguments.length === 0) return this;
    var param = arguments[0], str= this;
    if (param === null) {
        return ''
    }
    if(typeof(param) === 'object') {
        for(var key in param)
            str = str.replace(new RegExp("\\{" + key + "\\}", "g"), param[key]);
        return str;
    } else {
        for(var i = 0; i < arguments.length; i++)
            str = str.replace(new RegExp("\\{" + i + "\\}", "g"), arguments[i]);
        return str;
    }
}


Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.prototype.config_env = require(`./build/${process.env.BUILD_ENV}.js`)
new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
